module.exports = __webpack_public_path__ + "static/img/11_4Archive_15j_KaprowLossactivitybooklet_3.563e5ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_15j_KaprowLossactivitybooklet_3.jpg
// module id = k18X
// module chunks = 0